import React, { useState, useEffect, useRef } from 'react';
import { useSearchParams, Link, useNavigate, useParams } from 'react-router-dom';
import axios from "axios";
import MaterialTable from "material-table";
import { translate } from "../../../../config/lang";
import { defaultVariables } from "../../../../config";
import { isAdmin, RWN, TableCount, TablePage } from "../../../../config/Permissions";
import {
    Hidden,
    IconButton,
    Typography
} from "@mui/material";
import { showTableDate } from "../../../../config/values";
import Button from "@mui/material/Button";
import AppCardLoaderFields from "../../../components/loaders/AppCardLoaderFields";
import Grid from "@mui/material/Grid2";
import {AccountBalanceWalletOutlined, AddBox, ChevronLeftRounded, ChevronRightRounded} from "@mui/icons-material";
import { tableIcons } from "../../../../config/design/TableIcons";
import { getDataTableLocalization } from "../../../../config/Translate";
import { Styles } from "../../../../config/design/styles";
import { withStyles } from "@mui/styles";
import { useSnackbar } from "notistack";
import {connect} from "trim-redux";
import WorkspacePremiumRoundedIcon from '@mui/icons-material/WorkspacePremiumRounded';
import Tooltip from "@mui/material/Tooltip";
import {useTranslation} from "react-i18next";
import {CircleCheckBig, CircleX, Wallet} from "lucide-react";
function Users({ classes,user,type }) {
    const tableRef = useRef();
    const { role: roleParam } = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const [searchParams, setSearchParams] = useSearchParams();
    const { t } = useTranslation();

    const [columns, setColumns] = useState([
        { title:
                t('fullName'),
            field: 'name',
            editable: 'never' ,
            render: rowData => (
                rowData.role === "admin" ?
                    <Typography style={{display:"flex",alignItems:"center"}}><Tooltip title={t('admin')}> <WorkspacePremiumRoundedIcon color="primary"/> </Tooltip> {rowData.fullName}</Typography>
                    :
                    <Typography style={{display:"flex",alignItems:"center"}}><Tooltip title={t('viewWallet')}> <IconButton component={Link} size="small" to={`/panel/manage/wallets/transactions/${rowData.wallet?.id}`}><Wallet /></IconButton> </Tooltip> {rowData.fullName}</Typography>
            )
        },
        { title: t('mobile'), field: 'mobile', editable: 'never' },
        { title: t('email'), field: 'email', editable: 'never' },
        {
            title: t('isActive'),
            field: 'active',
            editable: 'never',
            hidden: type !== "courier",
            render: rowData => (
                <>
                    {
                        !!rowData.active ?
                            <CircleCheckBig className="lucide-icon-secondary"/>
                            :
                            <CircleX/>
                    }
                </>
            )
        },
        {
            title: t('role'),
            field: 'role',
            lookup: RWN(),
            hidden: type === "courier"
        },
        {
            title: t('registerDate'),
            editable: 'never',
            field: 'created_at',
            hidden: type === "courier",
            render: rowData => (
                <Typography className={classes.dateTable}>
                    {showTableDate(rowData.created_at)}
                </Typography>
            )
        },
        {
            title: t('activity'),
            editable: 'never',
            field: 'activity',
            hidden: !isAdmin(),
            render: rowData => (
                <Button
                    variant="outlined"
                    color="secondary"
                    component={Link}
                    to={`/panel/manage/${type === "courier" ? "couriers" : "users"}/edit/${rowData.id}`}
                    endIcon={<ChevronRightRounded />}
                    size={"small"}
                    style={{ margin: 5 }}
                >
                    {t('details')}
                </Button>
            )
        }
    ]);
    const [loading, setLoading] = useState(false);
    const [role, setRole] = useState(roleParam || "all");


    const loadData = () => {
        tableRef.current && tableRef.current.onQueryChange();
    };
    const removeParam = (paramName) => {
        // Clone the current params
        const newParams = new URLSearchParams(searchParams);

        // Delete the specific parameter
        newParams.delete(paramName);

        // Update the URL
        setSearchParams(newParams);
    };


    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    };
    const requestData = new FormData();
    requestData.append('role', role);

    return (
        <>
            {loading ? <AppCardLoaderFields /> : (
                <Grid container spacing={2}>

                    <Grid item size={12} className="main-table">
                        <MaterialTable
                            parentChildData={(row, rows) => rows.find(a => a.id === row.parentId)}
                            tableRef={tableRef}
                            icons={tableIcons}
                            title={
                            <>
                            {
                                isAdmin() ?
                                    <Link to='/panel/manage/users/add'>
                                        <Hidden mdDown>
                                            <Button variant="contained" color="secondary" startIcon={<AddBox />}>
                                                {t('addUser')}
                                            </Button>
                                        </Hidden>
                                        <Hidden mdUp>
                                            <IconButton color="primary">
                                                <AddBox />
                                            </IconButton>
                                        </Hidden>
                                    </Link>
                                    :
                                    <>

                                    </>

                            }

                            </>
                            }
                            localization={getDataTableLocalization()}
                            columns={columns}
                            data={query =>
                                new Promise((resolve) => {
                                    axios.post(`${defaultVariables.url}/users/get-with-filter?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}&type=${type}`, requestData, config)
                                        .then(response => {
                                            const fetchedData = response.data.data.map(row => ({
                                                email: row.email,
                                                mobile: row.mobile,
                                                fullName: row.first_name+" "+row.last_name,
                                                wallet: row.wallet,
                                                role: row.role ? row.role.name : null,
                                                id: row.id,
                                                active: !!row.courier_active && !row.courier_leave,
                                                created_at: row.created_at
                                            }));
                                            resolve({
                                                data: fetchedData,
                                                page: response.data.current_page - 1,
                                                totalCount: response.data.total
                                            });
                                        })
                                        .catch(error => console.log(error));
                                })
                            }
                            options={{
                                pageSize: TablePage,
                                pageSizeOptions: TableCount,
                                sorting: false,
                                draggable: false
                            }}
                        />
                    </Grid>
                </Grid>
            )}
        </>
    );
}

const mstp = state => ({
    features: state.features,
    locale: state.locale,
    user: state.user,
});

export default withStyles(Styles)(connect(mstp)(Users));
